import React from 'react'
import CheckPermissions from './CheckPermissions'
import AuthorizedRoute from './AuthorizedRoute'
import Secured from './Secured'
import { Authority } from './typings.d'

interface Params {
  children: React.ReactChild | React.ReactNodeArray | React.ReactPortal
  authority: Authority
  noMatch?: React.ReactChild | React.ReactNodeArray | React.ReactPortal | null
}

class Authorized extends React.PureComponent<Params> {
  public static AuthorizedRoute: typeof AuthorizedRoute

  public static Secured: typeof Secured

  public static check: typeof CheckPermissions

  public render(): ReturnType<typeof CheckPermissions> {
    const { children, authority, noMatch = null } = this.props
    const childrenRender = typeof children === 'undefined' ? null : children

    return CheckPermissions(authority, childrenRender, noMatch)
  }
}

export default Authorized
